import React from 'react';

import { createPartnerRegistrationManagerLayotClassName } from './partnerRegistrationManagerLayoutStyes';

type Props = {
  content: React.ReactNode;
};

export const PartnerRegistrationManagerLayoutComponent = (props: Props) => {
  const { content } = props;

  const wrapperClassName = createPartnerRegistrationManagerLayotClassName(
    'wrapper'
  );

  const bodyClassName = createPartnerRegistrationManagerLayotClassName('body');

  const contentClassName = createPartnerRegistrationManagerLayotClassName(
    'content'
  );

  return (
    <div className={wrapperClassName}>
      <div className={bodyClassName}>
        <div className={contentClassName}>{content}</div>
      </div>
    </div>
  );
};
